interface FocusMoveOptions {
  readonly scroll?: boolean;
}

type ActiveElementRoot = Pick<Document, "activeElement">;

function canReceiveFocus(element: Element | null): element is HTMLElement {
  return (
    element !== null &&
    "focus" in element &&
    typeof element.focus === "function"
  );
}

export function focusTarget(
  target: Element | null,
  { scroll = true }: FocusMoveOptions = {},
) {
  if (!canReceiveFocus(target)) return false;

  target.focus({ preventScroll: true });
  if (scroll) {
    target.scrollIntoView({ block: "start" });
  }

  return true;
}

export function captureFocusReturn(root: ActiveElementRoot = document) {
  const previousFocus = root.activeElement;

  return () => {
    if (!canReceiveFocus(previousFocus) || !previousFocus.isConnected) {
      return false;
    }

    return focusTarget(previousFocus, { scroll: false });
  };
}
